module.exports = __webpack_public_path__ + "img/lenglian.9fa3e577.png";